import base from '@/http/url_base';

export default {
  DEMANDE: base.API_ACHAT + '/demandes',
  GET_REQUIREMENTS: base.API_ACHAT + '/demandes/requirements',
  VALIDER: base.API_ACHAT + '/demandes/valider',
  REFUSER: base.API_ACHAT + '/demandes/refuser',
  REINITIALISER: base.API_ACHAT + '/demandes/reinitialiser',
};
